const initialState = {
  data: [],
};

const integrationsRedurcer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_INTEGRATIONS':
      return {
        ...state,
        data: action.payload,
      };
    default:
      return state;
  }
};

export default integrationsRedurcer;
